import React from "react";
import { Box, Divider, List, ListItem, ListItemText } from "@mui/material";
import { useSelector } from "../../../store";
import AlertComponent from "../ActiveAlerts/AlertComponent";

interface Props {
  handleClose: () => void;
}

const AlertMenu: React.FC<Props> = (props) => {
  const { handleClose } = props;

  const { siteAlerts } = useSelector((store) => store.alert);

  return (
    <Box width={250} display="flex" role="presentation" onClick={handleClose}>
      <List sx={{ width: "100%" }}>
        <Box>
          <ListItem>
            <ListItemText
              primary="Notifications"
              primaryTypographyProps={{
                fontSize: 22,
                fontWeight: "bold",
                color: "primary",
              }}
            />
          </ListItem>
        </Box>
        <Divider sx={{ margin: 1 }} />
        {siteAlerts &&
          siteAlerts.map((alert) => {
            return <AlertComponent key={alert.id} alert={alert} />;
          })}
      </List>
    </Box>
  );
};

export default AlertMenu;
